import api from "./api"

export const getDriverFormData = async () => {
  const response = await api.get("/drivers/form-data")
  return response.data
}

export const getDrivers = async (params = {}) => {
  const response = await api.get("/drivers", { params })
  return response.data
}

export const getDriverById = async (driverId) => {
  const response = await api.get(`/drivers/${driverId}`)
  return response.data
}

export const createDriver = async (driverData) => {
  const response = await api.post("/drivers", driverData)
  return response.data
}

export const updateDriver = async (driverId, driverData) => {
  const response = await api.put(`/drivers/${driverId}`, driverData)
  return response.data
}

export const deactivateDriver = async (driverId) => {
  const response = await api.post(`/drivers/${driverId}/deactivate`, {})
  return response.data
}